import styled from "@emotion/styled";
import btnBg from "../img/buttonImgBg.png";

export const Button = styled.button`
  width: 100%;
  height: 50px;
  border-radius: 10px;
  border: none;
  cursor: pointer;

  font-family: "EBENYA", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  letter-spacing: 1px;

  /* начальное состояние */
  background: linear-gradient(135deg, #ffd40b 0%, #ffdc0a 100%);
  color: #2f2410;
  box-shadow: 0 10px 30px rgba(255, 200, 20, 0.35);

  transition:
    background 0.3s ease-in-out,
    color 0.3s ease-in-out,
    transform 0.2s ease-in-out,
    box-shadow 0.3s ease-in-out;

  &:hover {
    background: #ffffff;
    color: #2f2410;
  }

  &:active {
    background: #ffffff;
    box-shadow: 0 8px 24px rgba(255, 200, 20, 0.28);
  }
`;
